module.exports = __webpack_public_path__ + "static/media/calculator-icon.1aaea9d2.svg";